export const articles = [
  {
    id: 1,
    slug: 'galagame-2025-summer-event',
    title: 'galagame 2025夏日狂欢节盛大开启，百万奖励等你来拿',
    excerpt: 'galagame 年度最盛大的夏日活动正式启动，参与即有机会赢取丰厚奖励，包括限定皮肤、游戏道具及现金大奖。',
    content: `galagame 2025夏日狂欢节已于本月正式拉开帷幕，这是 galagame 平台年度最受期待的大型活动之一。本次活动将持续整个夏季，为所有玩家带来前所未有的游戏体验和丰厚奖励。

## 活动亮点

本次夏日狂欢节推出了多项精彩活动内容：

**1. 每日签到奖励**
活动期间，玩家每日登录 galagame 即可领取签到奖励，连续签到7天可获得限定夏日皮肤。

**2. 竞技排行榜**
参与指定游戏的竞技模式，根据排名获得积分。赛季结束后，排行榜前100名玩家将分享百万现金奖池。

**3. 限时任务挑战**
完成每日限时任务，收集夏日代币，可在活动商店兑换独家道具和限定外观。

**4. 邀请好友福利**
邀请新用户注册 galagame，双方均可获得丰厚的邀请奖励，最高可获得价值500元的游戏礼包。

## 参与方式

玩家只需登录 galagame 官网或打开 galagame 客户端，进入活动中心即可参与全部活动。所有活动数据实时更新，奖励即时发放。

galagame 一直致力于为玩家提供最优质的游戏体验和最丰富的活动内容。此次夏日狂欢节规模空前，不容错过！`,
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20summer%20gaming%20festival%20celebration%20with%20colorful%20lights%20and%20confetti%2C%20game%20characters%20silhouettes%2C%20festive%20atmosphere%2C%20dark%20background%20with%20neon%20accents%2C%20energetic%20vibe%2C%20game%20event%20promotional%20style&width=1200&height=600&seq=article-summer-01&orientation=landscape',
    category: '活动',
    date: '2025-08-01',
    author: 'galagame 官方',
    readTime: '5分钟',
  },
  {
    id: 2,
    slug: 'galagame-new-games-launch',
    title: 'galagame 平台七月新游推荐：五款大作不容错过',
    excerpt: '本月 galagame 平台迎来了多款重磅新游上线，涵盖动作、RPG、策略等多个类型，总有一款适合你。',
    content: `七月对 galagame 平台来说是一个激动人心的月份，多款备受期待的新游戏正式上线。galagame 游戏评测团队精心挑选了五款最值得体验的新作，为大家带来详细的介绍。

## 本月推荐新游

**1. 《暗影突袭：幽灵行动》**
这款战术潜行动作游戏以其出色的画面表现和紧张刺激的玩法迅速赢得了玩家青睐。游戏中的AI系统极为智能，每一关都需要玩家精心策划。

**2. 《龙族传说：起源》**
作为 galagame 平台本月最重磅的 RPG 大作，《龙族传说：起源》打造了一个令人叹为观止的奇幻开放世界。游戏中的巨龙驯服系统极具创新性。

**3. 《深海探险：亚特兰蒂斯》**
这款水下探索 RPG 以其独特的美术风格和沉浸式叙事脱颖而出。深海世界的视觉呈现令人惊艳。

**4. 《巅峰对决：英雄竞技场》**
全新的 MOBA 竞技游戏，英雄设计独具匠心，战斗节奏紧凑刺激。目前已上线 30+ 位英雄。

**5. 《星际争霸：银河帝国》**
即时战略游戏的革新之作，在传统 RTS 基础上加入了创新的外交和贸易系统，策略深度大幅提升。

## 如何体验

以上游戏均已在 galagame 平台正式上线，玩家登录 galagame 即可下载体验。新用户注册还可享受首周免费试玩特权。

galagame 将持续为玩家带来更多优质游戏内容，敬请期待下月新游推荐！`,
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20five%20diverse%20video%20game%20cover%20arts%20displayed%20in%20a%20gallery%20style%2C%20dark%20background%20with%20spotlight%20effects%2C%20each%20game%20has%20distinct%20style%2C%20professional%20game%20showcase%2C%20modern%20design&width=1200&height=600&seq=article-newgames-02&orientation=landscape',
    category: '新游',
    date: '2025-07-15',
    author: 'galagame 评测组',
    readTime: '6分钟',
  },
  {
    id: 3,
    slug: 'galagame-esports-tournament',
    title: 'galagame 电竞赛事季正式启动，总奖金池突破千万',
    excerpt: 'galagame 宣布2025电竞赛季全面开启，涵盖多款热门竞技游戏，总奖金池高达1000万元人民币。',
    content: `galagame 官方今日宣布，2025年度电竞赛事季正式启动。本届赛事季规模空前，总奖金池突破1000万元人民币，创下 galagame 平台历史新高。

## 赛事安排

**《星际征途：无尽前线》职业联赛（GPL）**
作为 galagame 平台的旗舰电竞赛事，GPL 2025将分为春季赛和秋季赛两个赛季。每个赛季总奖金300万元。

**《王者征途：军团之战》全球锦标赛**
策略竞技类游戏的巅峰对决，来自全球32支顶尖战队将角逐200万元的总奖金。

**《巅峰对决：英雄竞技场》大师赛**
MOBA 品类的新锐赛事，首次举办即设立150万元奖金池，吸引了众多知名电竞俱乐部参赛。

**《极限竞速：街头狂飙》世界巡回赛**
赛事将在全球8个城市举办线下分站赛，总奖金250万元。

## 参赛方式

所有 galagame 注册用户均可通过游戏内报名通道参与选拔赛。选拔赛采用线上形式进行，晋级选手将受邀参加线下决赛。

galagame 电竞致力于打造公平、专业、高水平的竞技平台，为每一位热爱电竞的玩家提供展示自我的舞台。让我们一起见证新的传奇诞生！`,
    image: 'https://readdy.ai/api/search-image?query=Grand%20esports%20tournament%20stadium%20with%20massive%20LED%20screens%20displaying%20game%20footage%2C%20packed%20audience%20with%20cheering%20crowd%2C%20dramatic%20stage%20lighting%2C%20professional%20esports%20production%2C%20dark%20atmosphere%20with%20vibrant%20accents&width=1200&height=600&seq=article-esports-03&orientation=landscape',
    category: '电竞',
    date: '2025-07-20',
    author: 'galagame 电竞',
    readTime: '7分钟',
  },
  {
    id: 4,
    slug: 'galagame-membership-benefits',
    title: 'galagame 会员体系全面升级，尊享八大专属特权',
    excerpt: 'galagame 全新会员体系上线，从青铜到钻石五大会员等级，享受专属折扣、优先体验等八大权益。',
    content: `galagame 平台今日宣布会员体系全面升级，全新的五级会员制度为玩家带来前所未有的尊享体验。

## 会员等级体系

galagame 全新会员体系分为五个等级：

**青铜会员（免费）**
基础会员等级，所有注册用户自动获得。享受每日签到奖励、基础客服支持。

**白银会员（月费29元）**
享受5%游戏内消费折扣、每月3款游戏试玩权限、专属客服通道。

**黄金会员（月费59元）**
享受10%消费折扣、每月10款游戏试玩、新游优先体验权、每月专属礼包。

**铂金会员（月费99元）**
享受15%消费折扣、全部游戏试玩、新游提前48小时体验、专属限定皮肤、VIP客服。

**钻石会员（月费199元）**
享受20%消费折扣、全部特权、每月实物周边礼盒、线下活动优先参与权、1对1专属管家服务。

## 升级福利

为庆祝会员体系升级，即日起至8月31日，所有新开通黄金及以上会员的用户，首月享受半价优惠。

galagame 始终坚持为玩家创造最大价值，全新会员体系将让你的游戏之旅更加精彩！`,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20VIP%20membership%20concept%20with%20five%20tiered%20metal%20cards%20from%20bronze%20to%20diamond%2C%20elegant%20dark%20background%2C%20golden%20and%20diamond%20accents%2C%20premium%20lifestyle%20feel%2C%20sophisticated%20lighting&width=1200&height=600&seq=article-membership-04&orientation=landscape',
    category: '公告',
    date: '2025-07-25',
    author: 'galagame 运营',
    readTime: '4分钟',
  },
  {
    id: 5,
    slug: 'galagame-community-guide',
    title: 'galagame 社区攻略：从新手到大神的进阶之路',
    excerpt: '无论你是刚接触 galagame 的新手还是资深玩家，这份社区攻略都能帮你在 galagame 平台上获得更好的体验。',
    content: `欢迎来到 galagame 社区！无论你是刚接触 galagame 的新手玩家，还是已经征战多年的老玩家，这份社区攻略都将帮助你更好地享受 galagame 平台的每一刻。

## 新手入门指南

**第一步：注册账号**
访问 galagame 官网，点击右上角注册按钮，使用手机号或邮箱完成注册。新用户注册即可获得价值50元的新手礼包。

**第二步：完善个人资料**
上传头像、设置昵称、填写游戏偏好，完整的个人资料能帮助你更快找到志同道合的游戏伙伴。

**第三步：下载游戏客户端**
galagame 提供统一的游戏客户端，一站式管理和启动所有平台游戏，无需为每款游戏单独下载。

**第四步：加入社区**
加入 galagame 官方社区，参与讨论、分享攻略、结交好友。活跃的社区成员还能获得额外积分奖励。

## 进阶技巧

**游戏选择策略**
根据自己的游戏偏好和时间安排选择合适的游戏类型。galagame 的智能推荐系统会根据你的游玩记录推荐最适合你的游戏。

**提升竞技水平**
参与 galagame 电竞训练营，向职业选手学习技巧。观看赛事回放，分析高手操作。

**获取最大收益**
合理利用 galagame 每日任务和活动系统，最大化积分和奖励收益。关注官方公告，不错过任何福利活动。

galagame 社区欢迎每一位热爱游戏的你！`,
    image: 'https://readdy.ai/api/search-image?query=Gaming%20community%20concept%20with%20diverse%20gamers%20avatars%20connected%20through%20digital%20network%2C%20futuristic%20interface%20elements%2C%20warm%20and%20welcoming%20atmosphere%2C%20social%20gaming%20theme%2C%20dark%20background%20with%20colorful%20connections&width=1200&height=600&seq=article-community-05&orientation=landscape',
    category: '攻略',
    date: '2025-07-10',
    author: 'galagame 社区',
    readTime: '8分钟',
  },
  {
    id: 6,
    slug: 'galagame-security-update',
    title: 'galagame 安全系统重大升级，全方位守护账号安全',
    excerpt: 'galagame 推出新一代账号安全防护系统，采用多重加密和AI风险识别技术，确保玩家账号万无一失。',
    content: `galagame 平台始终将玩家账号安全放在首位。近日，galagame 完成了安全系统的全面升级，为每一位玩家提供更加可靠的安全保障。

## 升级内容

**1. 双重认证（2FA）全面升级**
支持短信验证码、邮箱验证码和身份验证器App三种方式，玩家可自由组合使用。

**2. AI风险识别系统**
基于机器学习的异常行为检测系统，能够实时识别并阻止可疑登录和异常交易。

**3. 设备管理功能**
用户可在 galagame 安全中心查看所有登录设备，远程踢出可疑设备，设置信任设备白名单。

**4. 数据加密传输**
所有用户数据采用量子安全级别的端到端加密传输，确保数据在传输过程中不会被窃取。

**5. 隐私保护模式**
新增隐私保护模式，开启后可隐藏在线状态、游戏记录等个人信息。

## 安全建议

galagame 安全团队建议所有玩家：
- 立即开启双重认证
- 定期修改密码
- 不要在第三方平台泄露账号信息
- 警惕钓鱼网站和虚假客服

galagame 将持续投入资源提升平台安全性，为玩家营造安全、可靠的游戏环境。`,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20cybersecurity%20concept%20with%20digital%20shield%20and%20lock%20icons%2C%20dark%20background%20with%20glowing%20green%20circuit%20patterns%2C%20holographic%20interface%20elements%2C%20professional%20tech%20aesthetic%2C%20secure%20and%20trustworthy%20feel&width=1200&height=600&seq=article-security-06&orientation=landscape',
    category: '公告',
    date: '2025-07-05',
    author: 'galagame 安全',
    readTime: '5分钟',
  },
];

export const articleCategories = [
  { name: '全部', slug: 'all' },
  { name: '活动', slug: 'activity' },
  { name: '新游', slug: 'new-games' },
  { name: '电竞', slug: 'esports' },
  { name: '公告', slug: 'announcement' },
  { name: '攻略', slug: 'guide' },
];